import React, { useState, useEffect } from 'react'
import { Row, Col, Table } from 'rsuite'
import GMap from '../../components/map/GMap'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { loadLocationHaveAll } from '../../components/location/Location'

export default function TargetGroupAndArea(props) {
  const { schema } = props
  const { Column, HeaderCell, Cell } = Table

  const [markers, setMarkers] = useState([])
  // const [locationList, setLocationList] = useState([])
  // const [isLoading, setIsLoading] = useState(false)

  // useEffect(() => {
  //   handleLocation()
  // }, [])

  // const handleLocation = async () => {
  //   setIsLoading(true)
  //   const location = await loadLocationHaveAll()
  //   setLocationList(location)
  //   setIsLoading(false)
  // }

  useEffect(() => {
    let arr = schema.area.values
    let _markers = []
    arr.map((item) => {
      let position = {
        lat: item.latitude,
        lng: item.longitude,
      }
      _markers.push(position)
    })
    setMarkers(_markers)
  }, [schema.area.values])

  // const generateTable = (dataList) => {
  //   if (dataList) {
  //     let _dataList = dataList.map((item) => {
  //       let dataTable = item
  //       let valList = item.location.split('-')
  //       let dataObj = locationList
  //       let keyValue = ''
  //       let province = ''
  //       let district = ''
  //       let subDistrict = ''

  //       for (let index = 0; index < valList.length; index++) {
  //         if (index === 0) {
  //           keyValue = valList[index]
  //         } else {
  //           keyValue += '-' + valList[index]
  //         }

  //         let obj
  //         dataObj?.forEach((item) => {
  //           if (item.value === keyValue) {
  //             obj = item
  //             return
  //           }
  //         })

  //         if (obj) {
  //           switch (index) {
  //             case 0:
  //               province = obj.label
  //               break
  //             case 1:
  //               district = obj.label
  //               break
  //             case 2:
  //               subDistrict = obj.label
  //               break
  //             default:
  //               break
  //           }

  //           dataObj = obj.children
  //         }
  //       }

  //       dataTable.province = province
  //       dataTable.district = district
  //       dataTable.subDistrict = subDistrict

  //       return dataTable
  //     })
  //     return _dataList
  //   }
  // }

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div>
            <p style={{ marginBottom: 10 }}>
              <b>{schema.targetGroup.targetCriteria.label || null} :</b>{' '}
              {schema.targetGroup.targetCriteria.value
                ? schema.targetGroup.targetCriteria.value
                : '- ไม่ได้ระบุ -'}
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 8 }}>
          <b>แสดงข้อมูลเกณฑ์การคัดเลือกกลุ่มเป้าหมายดำเนินการบริเวณนี้ :</b>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          {schema.targetGroup.criteriaList.options.map((item, index) => {
            if (schema.targetGroup.criteriaList.optionSelected.some((e) => e === item.value)) {
              return (
                <dl key={index} style={{ marginBottom: 20 }}>
                  <dt style={{ marginLeft: 20, marginBottom: 5 }}>
                    &#9679; {item.text}
                    <span>
                      {' '}
                      {item.numberOfPeople.preText +
                        ' ' +
                        item.numberOfPeople.value +
                        ' ' +
                        item.numberOfPeople.postText}
                    </span>
                  </dt>
                  <dd style={{ marginLeft: 20 }}>
                    <b>
                      &#45; {item.detail.text} :{' '}
                      {item.detail.value ? item.detail.value : '- ไม่ได้ระบุ -'}
                    </b>
                  </dd>
                </dl>
              )
            }
          })}
        </Col>
        {schema.targetGroup.criteriaList.optionSelected.length === 0 && (
          <Col xs={24} sm={12} md={8} lg={8}>
            <span> - ไม่ได้ระบุ - </span>
          </Col>
        )}
      </Row>
      <br />
      {/* {isLoading && <OverlayLoader />} */}
    </>
  )
}
